import PropTypes from 'prop-types';
import React from 'react';
import CountriesCounter from "../countries-counter/countries-counter";
import GlobalCountriesSelector from "../global-countries-selector/global-countries-selector";
import ListHeaderSearch from "../list-header-search/list-header-search";

var ListHeader = function ListHeader(_ref) {
  var header = _ref.header,
      selectedCountriesNumber = _ref.selectedCountriesNumber,
      totalCountriesNumber = _ref.totalCountriesNumber,
      onTerritorySelect = _ref.onTerritorySelect,
      onCountrySearch = _ref.onCountrySearch,
      onCountrySearchClose = _ref.onCountrySearchClose,
      searchQuery = _ref.searchQuery,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;
  return React.createElement("div", {
    className: "ListHeader"
  }, React.createElement("div", {
    className: "ListHeader-list-type"
  }, React.createElement("header", null, React.createElement("h4", {
    className: "ListHeader-header-text"
  }, header)), React.createElement(CountriesCounter, {
    selectedCountriesNumber: selectedCountriesNumber,
    totalCountriesNumber: totalCountriesNumber,
    formatMessage: formatMessage,
    messages: messages
  })), React.createElement("div", {
    className: "ListHeader-search"
  }, React.createElement(ListHeaderSearch, {
    onCountrySearch: onCountrySearch,
    onCountrySearchCancel: onCountrySearchClose,
    searchQuery: searchQuery,
    formatMessage: formatMessage,
    messages: messages
  })), React.createElement("div", {
    className: "ListHeader-global-selector"
  }, React.createElement(GlobalCountriesSelector, {
    onTerritorySelect: onTerritorySelect,
    formatMessage: formatMessage,
    messages: messages
  })));
};

ListHeader.propTypes = {
  header: PropTypes.string,
  selectedCountriesNumber: PropTypes.number,
  totalCountriesNumber: PropTypes.number,
  onTerritorySelect: PropTypes.func,
  onCountrySearch: PropTypes.func,
  onCountrySearchClose: PropTypes.func,
  searchQuery: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default ListHeader;